import { Root } from "@radix-ui/react-label"
import clsx from "clsx"

import { faIcon } from "@utils/faIcon"

import { Skeleton, TruncatableText } from "@particles"

import { Hint, HintTrigger, Icon } from "@atoms"

import styles from "./Label.module.scss"
import { LabelProps } from "./Label.types"

export default function Label(props: LabelProps) {
    const {
        label,
        variant = "default",
        state = "default",
        showStateIcon = true,
        truncate = false,
        tooltipOnTruncate = false,
        hint,
        htmlFor,
        className,

        isOptional,
        isLoading = false,
        isDisabled = false,
        _isFocused = false,

        ...rest
    } = props

    const iconSize = 14

    if (isLoading) {
        return (
            <div className={styles.skeleton}>
                <Skeleton height={10} width={120} borderRadius={0} />
            </div>
        )
    } else {
        return (
            <div className={styles.wrapper}>
                <Root
                    className={clsx(
                        styles.base,
                        {
                            [styles.clickable]: htmlFor !== undefined,
                            [styles.focusState]: _isFocused,
                            [styles.disabled]: isDisabled,
                        },
                        styles[`${variant}Variant`],
                        styles[`${state}State`],
                        className,
                    )}
                    htmlFor={htmlFor}
                    {...rest}
                >
                    {showStateIcon && state === "warning" && (
                        <Icon
                            icon={faIcon({ name: "triangle-exclamation", style: "solid" })}
                            className={styles.warningIcon}
                            size={iconSize}
                            container="fixedHeight"
                        />
                    )}
                    {truncate ? <TruncatableText text={label} tooltipOnTruncate={tooltipOnTruncate} /> : label}
                    {isOptional && <span className={styles.optional}>(Optional)</span>}
                </Root>
                {hint && (
                    <Hint {...hint}>
                        <HintTrigger />
                    </Hint>
                )}
            </div>
        )
    }
}
